import { imageDimensionsFromStream } from 'image-dimensions';

const MIN_SIZE = 100;
const CORS_PROXY = 'https://cors-proxy.utils.elfsightcdn.com';

const fetchImageDimensions = async (url, widgetToken) => {
  const currentURL = new URL(CORS_PROXY);
  currentURL.searchParams.set('url', url);
  currentURL.searchParams.set('widgetToken', widgetToken);

  const response = await fetch(currentURL);

  return await imageDimensionsFromStream(response.body);
};

const getImageNaturalDimensions = (image) => ({
  width: image.naturalWidth || MIN_SIZE,
  height: image.naturalHeight || MIN_SIZE
});

const loadImage = (image) =>
  new Promise((resolve) => {
    if (image.complete) {
      resolve(getImageNaturalDimensions(image));
    } else {
      image.addEventListener('load', () => {
        resolve(getImageNaturalDimensions(image));
      });
    }
  });

export const getImageDimensions = async (url, widgetToken) => {
  const image = new Image();
  image.src = url;

  if (image.complete) {
    return getImageNaturalDimensions(image);
  }

  try {
    const dimensions = await fetchImageDimensions(url, widgetToken);

    if (dimensions) {
      return dimensions;
    }
  } catch (error) {
    console.error('Error fetching image dimensions:', error);
  }

  return await loadImage(image);
};
